import { computed } from 'vue';
import { useAuthStore } from '@/stores/authStore';

export function useCartaoGestorFlag() {
  const authStore = useAuthStore();
  const ehGestor = computed(() => authStore.roleFlags.isGestorCartao);
  return { ehGestor };
}
